import {Dispatch, FC, SetStateAction} from 'react'
import {type} from 'os'
import {InvoicePaymentForm} from '../../core/_models'
import {isNotEmpty} from '../../../../../../../_metronic/helpers'
import {InvoicePaymentEditModalForm} from './InvoicePaymentEditModalForm'
import {InvoicePaymentEditModalHeader} from './InvoicePaymentEditModalHeader'

type props = {
  paymentItem: {
    paymentItem: InvoicePaymentForm | null | undefined
    setPaymentItem: React.Dispatch<React.SetStateAction<InvoicePaymentForm | null | undefined>>
  }
  payments?: {
    payments: InvoicePaymentForm[]
    setPayments: Dispatch<SetStateAction<InvoicePaymentForm[]>>
  }
  getSumNetPrice?: () => number
  getSumPayments?: () => number
  invoiceDate?: string
  enforceInvoiceDate?: boolean
  isDisabled?: boolean
  totalVatRate?: number
}

const InvoicePaymentEditModal: FC<props> = ({
  paymentItem,
  payments,
  getSumNetPrice,
  getSumPayments,
  invoiceDate,
  enforceInvoiceDate = false,
  isDisabled = false,
  totalVatRate = 0,
}) => {
  // A payment opened from its row is edited, not added (509, as the item dialog).
  const isEditing = !!paymentItem.paymentItem && isNotEmpty(paymentItem.paymentItem)
  const title = isDisabled
    ? 'اطلاعات پرداخت'
    : isEditing
    ? 'ویرایش پرداخت'
    : 'افزودن پرداختی به صورتحساب'
  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_invoice'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered modal-xl modal-fullscreen-sm-down mp-invoice-subdialog'>
          {/* begin::Modal content */}
          <div className='modal-content' style={{minHeight: '75vh'}}>
            <InvoicePaymentEditModalHeader title={title} paymentItem={paymentItem} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y'>
              <InvoicePaymentEditModalForm
                paymentItem={paymentItem}
                payments={payments}
                getSumNetPrice={getSumNetPrice}
                getSumPayments={getSumPayments}
                invoiceDate={invoiceDate}
                enforceInvoiceDate={enforceInvoiceDate}
                isDisabled={isDisabled}
                totalVatRate={totalVatRate}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {InvoicePaymentEditModal}
